/**
 * Normalize spoken transcript for deterministic intent matching.
 * Strips a leading Ashley wake word so "Ashley, open payroll" matches "open payroll".
 * @param {string} transcript
 */
export function normalizePhrase(transcript) {
  return String(transcript || "")
    .toLowerCase()
    .trim()
    .replace(/[^\w\s']/g, " ")
    .replace(/\s+/g, " ")
    .replace(/^(hey\s+)?ashley\s+/, "")
    .trim();
}
